export default function cumsum(values, valueof) {
  var sum = 0, index = 0;
  return Float64Array.from(values, valueof === undefined
    ? v => (sum += +v || 0)
    : v => (sum += +valueof(v, index++, values) || 0));
}


//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/cumsum.js
// module id = 409
// module chunks = 0